import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import { digObject, sortArrayBy } from 'functions/utilities'

import { memberRoles } from 'functions/teamMember'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import ElementContainer from '../../ElementContainer'

const findContainer = items => items.find(item => item.item_type === 'container')

const findUsers = (users, teamMemberIds = []) => {
  if (!users || !teamMemberIds) return []

  return teamMemberIds.map((teamMemberId) => {
    const user = Object.values(users).find(u => u.id === teamMemberId)
    return user
  }).filter(u => u)
}

const mergeUser = (users, images, teamMembers) => {
  if (!users || !images || !teamMembers) return []

  const mergedTeamMembers = Object.values(users).map((user) => {
    const actable = digObject(user, 'actable', {})
    const image = Object.values(images).find(i => i.imageable_id === user.id)
    const teamMember = Object.values(teamMembers).find(member => member.user_id === user.id)
    const memberDetails = Object.values(memberRoles).find(member => member.key === teamMember.member_role)

    return {
      ...actable, ...user, ...image, ...memberDetails, ...teamMember,
    }
  })

  return sortArrayBy(mergedTeamMembers, 'asc', 'sort')
}

const Team = (props) => {
  const {
    callbacks: { registerActiveComponent },
    data,
    items,
  } = props

  const { shortcode } = data || {}

  const teamContainer = findContainer(items) || {}

  const defaultContext = useContext(GlobalContext)

  const {
    activeComponents,
    campaign: {
      team_id: campaignTeamId,
    },
    dataSource: {
      options: {
        team_id: dataSourceTeamId,
      },
    },
    images,
    teams,
    teamMembers: teamMembersEntity,
    users,
  } = defaultContext

  const team = Object.values(teams).find(t => t.id === dataSourceTeamId || campaignTeamId) || {}

  const teamMembers = Object.values(teamMembersEntity).filter(teamMember => teamMember.team_id === team.id) || {}
  const teamMemberUserIds = Object.values(teamMembers).map(member => member.user_id)

  const digitalPageUsers = findUsers(users, teamMemberUserIds)
  const mergedTeamMembers = mergeUser(digitalPageUsers, images, teamMembers)

  const teamContext = {
    ...team,
    teamMembers: mergedTeamMembers,
  }

  if (shortcode && !activeComponents[shortcode]){
    registerActiveComponent(shortcode, { count: mergedTeamMembers.length })
  }

  return (
    <AnimationWrapper>
      <div style={deviceStyle(teamContainer)}>
        <ElementContainer
          forwardContextToItems={teamContext}
          section={teamContainer}
          renderNested
          render={({ itemComponents }) => itemComponents.map(component => component)}
        />
      </div>
    </AnimationWrapper>
  )
}

Team.propTypes = {
  callbacks: PropTypes.shape({
    registerActiveComponent: PropTypes.func.isRequired,
  }),
  data: PropTypes.object,
  items: PropTypes.array.isRequired,
}

export default Team
